module.exports = __webpack_public_path__ + "img/007王泰锡.f3fb028a.png";